<template>
  <div id="jobList">
    <div class="common_top_wrap">
      <div class="common_tit">취업정보 안내</div>
      <div class="common_search_wrap">
        <select v-model="searchParams.searchType">
          <option value="">고용형태 선택</option>
          <option value="EMP01">정규직</option>
          <option value="EMP02">계약직</option>
          <option value="EMP03">파견직</option>
          <option value="EMP04">시간제</option>
          <option value="EMP05">촉탁직</option>
          <option value="EMP06">기타</option>
        </select>
        <input type="text" v-model="searchParams.searchText" placeholder="회사 또는 정보명 입력"/>
        <div class="btn_search" @click="search(1)">검색</div>
      </div>
    </div>
    <div class="job_list_wrap">
      <div class="no_list_data" v-if="list.length <= 0">검색 결과가 없습니다.</div>
      <div class="job_item" :key="'job_' + item.jobPid" v-for="item in list" @click="showJob(item)">
        <div class="top">
          <div><img src="../../assets/job/ic_job.svg" alt=""/></div>
          <div>
            <template v-if="item.employeeType === 'EMP01'">정규직</template>
            <template v-if="item.employeeType === 'EMP02'">계약직</template>
            <template v-if="item.employeeType === 'EMP03'">파견직</template>
            <template v-if="item.employeeType === 'EMP04'">시간제</template>
            <template v-if="item.employeeType === 'EMP05'">촉탁직</template>
            <template v-if="item.employeeType === 'EMP06'">기타</template>
          </div>
        </div>
        <div class="tit multiline_ellipsis">{{item.subject}}</div>
        <div class="desc">
          {{item.companyName}}
          ·
          <template v-if="item.salaryType === 'SAL01'">월급</template>
          <template v-if="item.salaryType === 'SAL02'">연봉</template>
          <template v-if="item.salaryType === 'SAL03'">시급</template>
          {{getNumberWithCommas(item.salary)}}원
        </div>
        <div class="type">
          <div>
            <template v-if="item.eduType === 'EDU01'">초등학교</template>
            <template v-if="item.eduType === 'EDU02'">중학교</template>
            <template v-if="item.eduType === 'EDU03'">고등학교</template>
            <template v-if="item.eduType === 'EDU04'">대학교(2, 3년제)</template>
            <template v-if="item.eduType === 'EDU05'">대학교(4년제)</template>
            <template v-if="item.eduType === 'EDU06'">대학원(석사)</template>
            <template v-if="item.eduType === 'EDU07'">대학원(박사)</template>
            <template v-if="item.eduType === 'EDU08'">학력무관</template>
            <template v-if="item.eduType === 'EDU09'">기타</template>
          </div>
          <div>
            <template v-if="item.careerType === 'CAR01'">경력직</template>
            <template v-if="item.careerType === 'CAR02'">신입</template>
            <template v-if="item.careerType === 'CAR03'">경력무관</template>
          </div>
        </div>
        <div class="line"><div></div></div>
        <div class="bottom">{{item.recruitStart}} ~ {{item.recruitEnd}}</div>
      </div>
    </div>
    <div class="list_bottom_wrap">
      <div class="btn_bottom" @click="addJob" v-if="this.mySession != null && this.mySession.userPid != null && this.mySession.userRole != null">작성</div>
      <div class="common_page_wrap">
        <paginate
          v-model="pageParams.page"
          :pageCount="pageParams.totalPage"
          :clickHandler="search"
          :prevText="'<'"
          :nextText="'>'"
          :containerClass="'page_wrap'">
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import job from '../../script/job'

export default {
  data () {
    return {
      isMobile: common.detectMobile(),
      // Common
      mySession: {},
      // Search
      searchTypeList: [],
      searchParams: {
        searchType: '',
        searchText: ''
      },
      // List
      filter: {
        page: 1,
        size: this.isMobile ? 4 : 9
      },
      list: [],
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 10,
        size: this.isMobile ? 4 : 9
      }
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
      }
    })
    if (this.$route.params != null && this.$route.params.searchParams != null) {
      this.searchParams = this.$route.params.searchParams
      this.search(1)
    } else {
      this.search(1)
    }
  },
  methods: {
    search (page) {
      this.filter = {
        page: page,
        size: this.isMobile ? 4 : 9
      }
      delete this.filter['employeeType']
      if (this.searchParams.searchType != null && this.searchParams.searchType.length > 0) {
        this.filter['employeeType'] = this.searchParams.searchType
      }
      delete this.filter['search']
      if (this.searchParams.searchText != null && this.searchParams.searchText.length > 0) {
        this.filter['search'] = this.searchParams.searchText
      }
      this.updateList()
    },
    updateList () {
      job.getJob(this.filter, response => {
        console.log('취업정보 목록', response)
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          this.list = data.list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '취업정보 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
      })
    },
    addJob () {
      this.$router.push({
        name: 'JobForm',
        params: {
          searchParams: this.searchParams
        }
      })
    },
    showJob (item) {
      job.getJob({
        jobPid: item.jobPid
      }, response => {
        if (response.data.resultCode === 1) {
          this.$router.push({
            name: 'JobView',
            params: {
              searchParams: this.searchParams,
              data: response.data.result.body
            }
          })
        } else {
          common.amsAlert('retry', '취업정보 목록을 불러오지 못했습니다.')
        }
      })
    },
    getNumberWithCommas (value) {
      return common.getNumberWithCommas(value)
    }
  }
}
</script>

<style scoped>
.mobile_wrap #jobList {
  padding: 0 16px;
  box-sizing: border-box;
}

#jobList .job_list_wrap .no_list_data {
  grid-column-end: 3;
  grid-row-end: 3;
}

.mobile_wrap #jobList .job_list_wrap .no_list_data {
  grid-column-end: 2;
  grid-row-end: 4;
}
</style>



// WEBPACK FOOTER //
// src/components/job/List.vue